import React from "react";
import { useLanguage } from "../LanguageContext";
import translations from "../translations";

const Header = () => {

  const { language, toggleLanguage } = useLanguage();

  return (
    <header className="w-full py-8">

      <div className="w-full text-center text-white">
        <div className="border-t-4 border-black mb-2"></div>
        <h1 className="bg-gray-800 text-center text-2xl font-bold text-orange-500" style={{ whiteSpace: 'pre-wrap' }}>
          {translations[language].title}
        </h1>
        <div className="border-b-4 border-black mt-2"></div>
      </div>

      {/* Botão para alternar idioma */}
      <div className="flex justify-end mt-4">
        <button onClick={toggleLanguage} className="flex items-center space-x-2 p-2 rounded-md ">
          <img
            src={language === "en" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Flag_of_Brazil.svg/1920px-Flag_of_Brazil.svg.png" : "https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_the_United_States.svg"}
            alt="Trocar Idioma"
            className="w-8 h-5"
          />
          <span className="text-black font-semibold">{language === "en" ? "PT" : "EN"}</span>
        </button>
      </div>
      
    </header>
  );
};

export default Header;
